import { HotelSearchWrapper } from "@website/accommodation-ui/hotel-search/hotel-search-wrapper";
import { VillaSearchPanel } from "@website/accommodation-ui/villa-search/villa-search-panel";
import { VillaSearchSummary } from "@website/accommodation-ui/villa-search/villa-search-summary";
import { VillaSearchPropertiesType } from "@website/accommodation-ui/villa-search/villa-search.types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { deepCompare } from "@website/utils/deep-compare";
import { useRouter } from "next/router";
import { FC, memo } from "react";

const Component: FC<VillaSearchPropertiesType> = (properties) => {
  const {
    isSearchPanelOpen,
    setIsSearchPanelOpen,
    searchPanelProperties,
    searchSummaryProperties,
    searchType = "city",
    filterProps
  } = properties;
  const router = useRouter();

  return (
    <div className="flex flex-row items-center gap-0 bg-white">
      <HotelSearchWrapper
        PanelElement={
          <VillaSearchPanel
            {...searchPanelProperties}
            searchType={searchType}
          />
        }
        SummaryElement={
          <VillaSearchSummary
            {...searchSummaryProperties}
            searchType={searchType}
          />
        }
        isSearchPanelOpen={isSearchPanelOpen}
        searchType={searchType}
        setIsSearchPanelOpen={setIsSearchPanelOpen}
      />
      <Button
        className={`${
          router.pathname?.includes("map")
            ? "!me-4 block md:!hidden"
            : "!hidden"
        }`}
        color="neutral"
        onClick={filterProps?.toggleFilterModal}
        variant="text"
      >
        <MaterialIcon className="text-headline-6" name="tune" />
      </Button>
    </div>
  );
};

export const VillaSearch = memo(Component, deepCompare);
